import { ObservablePropType } from "../ObservablePropType";
import moment from "moment";
// import { idRepo } from 'venuescanner-js/tools/elemental'
// window.idRepo = idRepo
class DATE extends ObservablePropType {
  constructor(parent, value, options = null) {
    // if (typeof(options) !== 'undefined') {
    //   if (!opts) {
    //     opts = options ? options : {}
    //   }else if (options) {
    //     opts = {...options,...opts}
    //   }
    // }else{
    //   console.log(options)
    // }
    // if (options) console.log(options)
    super(parent, value, options);
    // console.log(this.valueOf())
  }
  element = () => '<vs-input type="date"></vs-input>';
  parse(value) {
    if (typeof value === "string") {
      // console.log({string:value, options:this.options})
      if (this.options.format) {
        // console.log(value)
        // console.log(moment(value,this.options.format).toDate())
        const parsed = moment(value, this.options.format);
        if (parsed.isValid()) return parsed.toDate();
        return null;
      } else {
        return moment(value).toDate();
      }
    }
    // console.log(this.options)
    // console.log({value}, value && moment(value).toDate())
    // console.log({value:value})
    return value && moment(value).toDate();
  }
  toJSON() {
    const value = this.valueOf();
    if (value && this.options.format) {
      return moment(value).format(this.options.format);
    }
    return value;
  }
  constructorName = "DATE";
}

export default DATE;
